import React from "react";
import "./Switch.css";
import SlSwitch from "@shoelace-style/shoelace/dist/react/switch";
interface Props {
  checked?: boolean;
  label?: string;
  onChange?: () => void;
  className?: string;
  disabled?: boolean;
  size?: "small" | "medium" | "large";
}

function Switch(props: Props) {
  const { 
    checked = false, 
    label = "", 
    className = "", 
    onChange = () => {}, 
    disabled = false,
    size = "medium"
  } = props;

  return (
    <SlSwitch 
      onSlChange={disabled ? () => { } : onChange} 
      className={className} 
      checked={checked} 
      disabled={disabled}
      size={size}
    >
      {label}
    </SlSwitch>
  );
}

export default Switch;
